import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=81d3dcda&"
import script from "./AppSidebar.vue?vue&type=script&lang=js&"
export * from "./AppSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81d3dcda')) {
      api.createRecord('81d3dcda', component.options)
    } else {
      api.reload('81d3dcda', component.options)
    }
    module.hot.accept("./AppSidebar.vue?vue&type=template&id=81d3dcda&", function () {
      api.rerender('81d3dcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/auth/AppSidebar.vue"
export default component.exports